import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export interface ProfessionalScheduleSlot {
  id?: number;
  professional_id?: number;
  day_of_week: number;
  start_time: string;
  end_time: string;
  break_label?: string | null;
  work_label?: string | null;
}

export interface SyncProfessionalSchedulePayload {
  schedules: Array<{
    day_of_week: number;
    start_time: string;
    end_time: string;
    break_label?: string;
    work_label?: string;
  }>;
}

export const getSchedules = (
  professionalId: number
): Promise<ApiResponse<ProfessionalScheduleSlot[]>> =>
  api.get<ApiResponse<ProfessionalScheduleSlot[]>>(
    `/professionals/${professionalId}/schedules`
  );

export const syncSchedules = (
  professionalId: number,
  payload: SyncProfessionalSchedulePayload
): Promise<ApiResponse<ProfessionalScheduleSlot[]>> =>
  api.create<ApiResponse<ProfessionalScheduleSlot[]>>(
    `/professionals/${professionalId}/schedules`,
    payload
  );
